/* eslint no-useless-escape: 0 */
import { escapeRegexCharacters } from "./escapeRegexCharacters";

describe("escapeRegexCharacters", () => {
    it("escapes regex characters", () => {
        const stringToEscape = "Hell(o $*W|r.d";
        const result = escapeRegexCharacters(stringToEscape);
        expect(result).toBe(`Hell\(o \$\*W\|r\.d`);
    });
});
